import {stringifyId} from '../../../../types'
import type {
  HolderType,
  PolicyEntry,
  PolicyType,
  Settings,
  UpdatePolicyPayload,
} from '../CleanupProjectPage.types'

import {ERROR_MESSAGES} from './EditForm.constants'
import type {EditFormState, FormGroup} from './EditForm.types'

export const calculateEntityDefaults = (
  policy: PolicyType | null | undefined,
): FormGroup | null | undefined => {
  if (policy == null) {
    return null
  }

  const {ownPolicy, policyParameters, levelDescription, policyDescription} = policy
  return {
    custom: ownPolicy,
    days:
      policyParameters['keepDays.count'] != null
        ? parseInt(policyParameters['keepDays.count'], 10)
        : null,
    builds:
      policyParameters['keepBuilds.count'] != null
        ? parseInt(policyParameters['keepBuilds.count'], 10)
        : null,
    error: null,
    default: ownPolicy
      ? null
      : `${levelDescription ? `${levelDescription} ` : ''}${policyDescription || ''}`,
  }
}
export const VALIDATIONS = {
  not_specified: (entity: FormGroup): null | string =>
    entity.custom && ![entity.days, entity.builds].filter(Boolean).length
      ? ERROR_MESSAGES.not_specified
      : null,
}

const adaptFormGroupToSettings = ({
  custom,
  days,
  builds,
  pattern,
}: FormGroup): Settings | null | undefined =>
  custom
    ? {
        daysCount: days,
        buildsCount: builds,
        artifactPatterns: pattern,
      }
    : null

export const adaptFormToPolicy = ({
  artifacts,
  everything,
  history,
  dependencies,
  policyEntry,
  type,
}: EditFormState & {
  policyEntry: PolicyEntry
  type: HolderType
}): UpdatePolicyPayload => ({
  holder: type,
  holderId: stringifyId(policyEntry.internalId),
  everythingSettings: adaptFormGroupToSettings(everything),
  historySettings: adaptFormGroupToSettings(history),
  artifactsSettings: adaptFormGroupToSettings(artifacts),
  preventDependencies: dependencies === 'default' ? null : dependencies !== 'do_not_prevent',
})
